import React from 'react';
import { Link } from 'react-router-dom';
import { Flame } from 'lucide-react';
import { getHeroBackground } from './Hero';

const promotions = [
  {
    title: 'Weekend BBQ Combo',
    description: 'Whole Chicken + 2 Sides + 2 Drinks — For 2 persons',
    price: 'UGX 65,000',
    badge: 'Save 20%',
    days: ['saturday', 'sunday'],
  },
  {
    title: 'Lunch Special',
    description: 'Any Burger + Soda + Chips — Mon to Fri 12-3PM',
    price: 'UGX 18,000',
    badge: 'Hot Deal',
    days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
  },
  {
    title: 'Family Sunday',
    description: '2 Whole Chickens + 4 Sides + 4 Drinks — Feeds 6',
    price: 'UGX 120,000',
    badge: 'Best Value',
    days: ['sunday'],
  },
];

const PromotionsStrip = () => {
  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
  const activePromos = promotions.filter(p => p.days.includes(today));
  const heroBg = getHeroBackground();

  if (activePromos.length === 0) return null;

  return (
    <section className="section-padding-sm" style={{
      position: 'relative', backgroundColor: '#1A1A1A', overflow: 'hidden'
    }}>
      <div style={{ position: 'absolute', inset: 0, zIndex: 0, background: `url("${heroBg}") center/cover no-repeat` }} />
      <div style={{ position: 'absolute', inset: 0, zIndex: 1, background: 'linear-gradient(rgba(26,26,26,0.45), rgba(26,26,26,0.55))' }} />
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="text-center mb-4">
          <span className="section-subtitle">Limited Offers</span>
          <h2 className="text-white" style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.8rem', fontWeight: 600 }}>
            Today's Specials
          </h2>
        </div>
        <div className="row g-3">
          {activePromos.map((promo, i) => (
            <div key={i} className="col-md-4">
              <div style={{
                borderRadius: '16px', padding: '24px',
                background: 'linear-gradient(135deg, rgba(20,20,20,0.88), rgba(20,20,20,0.82))',
                border: '1px solid rgba(212,175,55,0.25)', height: '100%',
                boxShadow: '0 8px 28px rgba(0,0,0,0.35)'
              }}>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span style={{
                    backgroundColor: '#E74C3C', color: '#fff', padding: '4px 12px',
                    borderRadius: '20px', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '1px'
                  }}>{promo.badge}</span>
                  <Flame size={18} color="#D4AF37" />
                </div>
                <h5 className="text-white mb-2" style={{ fontFamily: 'Playfair Display, serif', fontWeight: 600 }}>{promo.title}</h5>
                <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.85rem', lineHeight: 1.6, marginBottom: '12px' }}>{promo.description}</p>
                <div className="d-flex align-items-center justify-content-between">
                  <span style={{ color: '#D4AF37', fontWeight: 700, fontSize: '1.2rem', fontFamily: 'Playfair Display, serif' }}>{promo.price}</span>
                  <Link to="/menu" style={{ color: '#D4AF37', fontSize: '0.8rem', fontWeight: 600, textDecoration: 'none' }}>
                    Order Now →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromotionsStrip;
